export default __webpack_public_path__ + "static/media/product1.712d62ab.png";